var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7145 3.8335C9.39598 3.8335 8.10705 4.22449 7.01072 4.95703C5.91439 5.68957 5.05991 6.73077 4.55532 7.94894C4.05074 9.16711 3.91872 10.5076 4.17595 11.8008C4.43319 13.094 5.06813 14.2819 6.00048 15.2142C6.93283 16.1466 8.12071 16.7815 9.41392 17.0387C10.7071 17.296 12.0476 17.1639 13.2657 16.6594C14.4839 16.1548 15.5251 15.3003 16.2576 14.204C16.9902 13.1076 17.3812 11.8187 17.3812 10.5002C17.3812 8.73205 16.6788 7.03636 15.4286 5.78612C14.1783 4.53587 12.4826 3.8335 10.7145 3.8335ZM9.76214 13.1624L7.38119 10.7815L8.13862 10.024L9.76214 11.6474L13.2907 8.11921L14.0506 8.8744L9.76214 13.1624Z",
    fill: "#22A06B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.5db4f64be52b1b8d3fac6eabeabf09ca.svg";
export { ForwardRef as ReactComponent };